import { render, staticRenderFns } from "./OnlineWaTemplateSelector.vue?vue&type=template&id=64cddd0e&scoped=true&"
import script from "./OnlineWaTemplateSelector.vue?vue&type=script&lang=js&"
export * from "./OnlineWaTemplateSelector.vue?vue&type=script&lang=js&"
import style0 from "./OnlineWaTemplateSelector.vue?vue&type=style&index=0&id=64cddd0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cddd0e",
  null
  
)

export default component.exports